<template>
  <article :data-categories=categories :class="{ 'critter': true, 'active': showCreator }">
    <picture>
      <source v-if="getWebpImage" :srcset="getWebpImage" type="image/webp">
      <img alt="" :src="getImage" class="critter__image" loading="lazy" width="100" height="100">
    </picture>
    <div class="critter__info">
      <ul class="link-list">
        <li><a class="critter__name" target="_blank" :href="creator.twitterHandle" rel="external">{{creator.name}}</a></li>
        <li v-if="creator.websiteUrl"><a class="critter__shop" target="_blank" :href="creator.websiteUrl" rel="external">Website</a></li>
      </ul>
      <span class="category-list">{{ categories }}</span>
    </div>
  </article>
</template>

<script>
export default {
  props: ['creator'],
  computed: {
    categories() {
      return this.creator.categorySelect.join(', ');
    },
    showCreator() {
      if(this.$store.state.categoryDisplay === '') {
        return true;
      } else {
        let singleCategories = this.categories.split(', ');
        return singleCategories.includes(this.$store.state.categoryDisplay);
      }
    },
    getImage() {
      // see if there's a local version of the image, if so, serve that, if not, get from source
      var filename = this.creator.profileUrl.split(/[\/]+/).pop();
      
      try {
        var fileExist = require(`../../public/creator-avatar/${filename}`);
        if (fileExist) {
          return `/public/creator-avatar/${filename}`;
        }
      } catch (e) {
        return this.creator.profileUrl;
      }
    },
    getWebpImage() {
      var filename = this.creator.profileUrl.split(/[\/]+/).pop();
      var fileNoExtension = filename.replace(/\.[^/.]+$/, "");

      try {
        var fileExist = require(`../../public/creator-avatar/${fileNoExtension}.webp`);
        if (fileExist) {
          return `/public/creator-avatar/${fileNoExtension}.webp`;
        }
      } catch (e) {
        return false;
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// CreatorDetail.vue?31145434